import { cn } from '@/lib/utils';
import { cva } from 'cva';
import React from 'react';

const variantMapping = {
  h1: 'p',
  h2: 'p',
  h3: 'p',
  h4: 'p',
  h5: 'p',
  h6: 'p',
  subtitle1: 'p',
  subtitle2: 'p',
  body1: 'p',
  body2: 'p',
  caption: 'p',
  overline: 'p',
};

const typography = cva('typography', {
  variants: {
    variant: {
      h1: ['text-28 font-semibold'],
      h2: ['text-20 font-semibold lg:text-26'],
      h3: ['text-20 font-semibold'],
      h4: ['text-16 font-normal lg:text-20'],
      h5: ['text-14 font-medium'],
      h6: ['text-13 font-medium'],
      dialogtitle: ['text-32 font-medium'],
      subtitle1: ['text-15 font-dmsans font-normal lg:text-18'],
      subtitle2: ['text-14 font-dmsans font-normal lg:text-16'],
      body1: ['text-15 font-dmsans font-normal'],
      body2: ['text-14 font-dmsans font-normal'],
      caption: ['text-11 font-medium'],
      button: ['text-16 font-medium'],
      chip: ['text-14 font-dmsans font-normal'],
      hyperlink: ['text-12 font-normal lg:text-15 hover:text-text-hyperlink'],
      avatar1: ['text-60 font-semibold lg:text-100'],
      avatar2: ['text-32 font-semibold'],
    },
    color: {
      primary: ['text-primary'],
      secondary: ['text-secondary'],
      textPrimary: ['text-text-primary'],
      textSecondary: ['text-text-secondary'],
      textDisabled: ['text-text-disabled'],
      hyperlink: ['text-text-hyperlink'],
      error: ['text-error'],
      white: ['text-white'],
    },
  },
  defaultVariants: {
    variant: 'body1',
    color: 'textPrimary',
  },
});

function Typography(props) {
  const { variant, children, className, component, color, ...rest } = props;
  const Tag = component || variantMapping[variant] || 'span';
  const { href } = rest;
  if (
    href &&
    component === 'a' &&
    !(href.startsWith('http') || href.startsWith('//'))
  ) {
    rest.href = `https://${href}`;
  }

  return (
    <Tag
      className={cn(
        typography({
          variant: variant,
          color: color,
        }),
        className,
      )}
      {...rest}>
      {children}
    </Tag>
  );
}

export default Typography;
